import React from "react";
import {Route} from "react-router-dom";
import Dashboard from "../../views/picking/dashboard";
import RequireAuthentication from "../../hoc/authentication/requireAuthentication";
import RetailerUnloader from "../../hoc/retailer/retailerUnloader";
import {sessionStore} from "../../utils/sessionStore";

let routes = [];
const applications = sessionStore.get("applications");

if (applications && applications["picking"]) {
    routes.push([
        <Route
            path="/picking"
            component={RequireAuthentication(RetailerUnloader(Dashboard))}
            exact
            key="dashboard"
        />,
    ])
}

export default routes;
